<div class="inputCheckBox inputputProcCheck">
  <input type="checkbox" [formControl]="formControl" [formlyAttributes]="field">
  <!-- <i *ngIf="field.props.label" class="pi pi-info-circle" pTooltip="abc"></i> -->
  <label pTooltip="Confidence: {{field.props['confidence']}}" tooltipPosition="top">{{field.props.label}} </label>
  <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
</div>
